import * as _ from 'lodash'
import * as d3 from 'd3'

let d3commaFormat = d3.format(',')
export function commaFormat(d) {
  return d < 1000 ? d3commaFormat(d) : d3commaFormat(Math.round(d))
}

export function getFieldLabel(id) {
  let labels = {
    RegulatedEntityName: 'Campaign',
    ExpenseCategoryName: 'Category',
    SupplierName: 'Supplier',
    DateIncurred: 'Date',
    RedactedSupportingInvoiceId: 'Invoice'
  }
  return labels[id]
}

export function getPluralFieldLabel(id) {
  let labels = {
    RegulatedEntityName: 'Campaigns',
    ExpenseCategoryName: 'Categories',
    SupplierName: 'Suppliers',
    DateIncurred: 'Dates'
  }
  return labels[id]
}

export function isInFieldGroupList(fieldGroupList, field, key) {
  if(!_.has(fieldGroupList, field))
    return false

  return _.includes(fieldGroupList[field], key)
}

export function splitIntoVisibleAndInvisibleItems({items, windowTop, windowBottom, h}) {
  // Figure out which items are visible based on scroll position so that we don't need to render off screen items

  let acc = 0
  let aboveVisibleItems = []
  let visibleItems = []
  let belowVisibleItems = []

  let padding = windowBottom - windowTop
  windowTop -= padding
  windowBottom += padding

  items.forEach(d => {
    let newAcc = acc + d.summary.numNodes * h

    if(acc < windowTop && newAcc < windowTop) {
      aboveVisibleItems.push(d)
    } else if(acc > windowBottom && newAcc > windowBottom) {
      belowVisibleItems.push(d)
    } else {
      visibleItems.push(d)
    }

    acc = newAcc
  })

  // console.log(aboveVisibleItems, visibleItems, belowVisibleItems)

  let aboveVisibleHeight = _.sumBy(aboveVisibleItems, d => d.summary.numNodes * h)
  let belowVisibleHeight = _.sumBy(belowVisibleItems, d => d.summary.numNodes * h)

  return {
    aboveVisibleHeight: aboveVisibleHeight,
    visibleItems: visibleItems,
    belowVisibleHeight: belowVisibleHeight
  }
}



// WEBPACK FOOTER //
// ./src/Helpers/index.js